import Model from 'flarum/Model';
import Discussion from 'flarum/models/Discussion';
import addSearchButton from './addSearchButton';
import addVoteLayout from './addVoteLayout';

app.initializers.add('fstln/flarum-ext-simplelikes', () => {

  //给discussion添加属性
  Discussion.prototype.vote_count = Model.attribute('vote_count');
  //在首页添加trending排序过滤
  addSearchButton();
  //discussion首页展示获赞数量
  addVoteLayout();

});
